import React from 'react';
import PropTypes from 'prop-types';
import { compose, withState, withHandlers, pure } from 'recompose';

import {
  StyledOptionsSocialMedia,
  StyledIconComments,
  StyledIconCommentsArticle,
  StyledIcon,
  StyledIconArticle,
  StyledBoxOption,
  StyledBoxOptionHome,
  StyledBoxText
} from './style';
import { Like, Share } from '../../../../assets/images/index';

const SocialMedia = ({
  className,
  activeLike,
  likesNumber,
  numberIcon,
  onClickAction,
  onComment,
  onShare,
  isHome,
  activeMessage,
  message,
  children,
  hastoken
}) => {
  const IconOption = isHome ? StyledIconArticle : StyledIcon;
  const IconComment = isHome ? StyledIconCommentsArticle : StyledIconComments;
  const BoxOption = isHome ? StyledBoxOptionHome : StyledBoxOption;

  return (
    <StyledOptionsSocialMedia className={className}>
      <IconOption
        svg={Like}
        size="m"
        hover
        active={activeLike}
        counter={likesNumber}
        onClick={() => onClickAction('LIKE')}
      />
      <IconComment
        size="m"
        hover
        numberComments={numberIcon}
        onClick={onComment}
      />
      {hastoken && <IconOption svg={Share} size="m" hover onClick={onShare} />}

      {children}

      <BoxOption active={activeMessage}>
        <StyledBoxText>{message}</StyledBoxText>
      </BoxOption>
    </StyledOptionsSocialMedia>
  );
};

const enhance = compose(
  withState('activeMessage', 'setActiveMessage', false),
  withState('timer', 'setTimer', null),
  withState('message', 'setMessage', null),
  withHandlers({
    onClickAction: ({
      setActiveMessage,
      setMessage,
      onLike,
      activeLike,
      timer,
      setTimer
    }) => value => {
      setActiveMessage(true);

      if (value === 'LIKE') {
        if (activeLike) {
          setMessage('YA NO ME GUSTA');
        } else {
          setMessage('ME GUSTA');
        }
        onLike();
      }

      clearTimeout(timer);

      setTimer(setTimeout(() => setActiveMessage(false), 2000));
    }
  }),
  pure
)(SocialMedia);

SocialMedia.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  activeMessage: PropTypes.bool,
  activeLike: PropTypes.bool,
  message: PropTypes.string,
  onShare: PropTypes.func,
  onComment: PropTypes.func,
  numberIcon: PropTypes.number,
  likesNumber: PropTypes.number,
  hastoken: PropTypes.bool
};

export default enhance;
